import IconWarning from '@apollo/icons/large/IconWarning.svg';
import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  ModalTitle,
} from '@apollo/orbit';
import React from 'react';

import { PermissionWarningContents } from 'src/components/permissionGuards/permissionWarning/PermissionWarning';

interface Props {
  /**
   * Determines whether the modal is open or not
   */
  isOpen: boolean;
  /**
   * Callback called when we attempt to close the modal
   */
  onClose: () => void;
}

/**
 * Modal to display when the user does not have permission to change the url
 * for a given variant.
 */
export const CannotSetVariantEndpointModal = ({ isOpen, onClose }: Props) => (
  <Modal isOpen={isOpen} onClose={onClose} size="lg">
    <ModalOverlay />
    <ModalContent>
      <ModalHeader>
        <ModalTitle className="flex items-center gap-4">
          <IconWarning className="size-8 text-neutral" />
          Sorry, you don't have permission.
        </ModalTitle>
      </ModalHeader>
      <ModalBody>
        <PermissionWarningContents />
      </ModalBody>
      <ModalFooter>
        <Button variant="primary" onClick={onClose} type="button">
          Close
        </Button>
      </ModalFooter>
    </ModalContent>
  </Modal>
);
